module.exports = __webpack_public_path__ + "927657f4e631d0b354ce399e92f21c70.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/cities-countries/China1.jpg
// module id = 3310
// module chunks = 0